module.exports = __webpack_public_path__ + "img/QR-codes-no-qr.e0e2003f.png";